import React from "react";
import Banner from "../components/UI-layout/banner";
import { CommonStyle } from "../styles/common-styles";
// import doorIconOne from '../public/images/fleet/car-door 1.png';
// import doorIconTwo from '../public/images/fleet/car-door 2.png';
// import UseWindowSize from "../hooks/helpers/useWindowSize";
import fleetImgOne from "../public/images/fleet/fleetmanagment.png";
import fleetImgTwo from "../public/images/fleet/fleetmanagment2.png";
import fleetImgThree from "../public/images/fleet/fleetmanagment3.png";
import fleetImgFour from "../public/images/pricing/handshake.png";
import Head from "next/head";
import { fleetMidContent, fleettopContent } from "../utils/wordings";
// import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import { PrimeWhite } from "../utils/constants";
import Image from "next/image";

function FleetManagment() {
  // const screenProps = UseWindowSize();
  // const { loaded, error, formCreated } = useHubspotForm({
  //     portalId: '8798012',
  //     formId: '30cf1cb8-9090-4f01-91e3-9b7a9f5ffe9c',
  //     target: '#my-hubspot-form'
  // });

  return (
    <div className="container-fluid p-0">
      <Head>
        <title>Paleo Car Care - Expert Auto Maintenance for Your Peace of Mind</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Discover the best in auto care with Paleo Car Care - Your trusted partner for top-notch car maintenance services." />
        <meta name="author" content="Paleo Car Care" />
        <meta property="og:title" content="Paleo Car Care - Fleet Repairs and Maintenance Services" />
        <meta
          property="og:image"
          itemProp="image"
          content="/images/referral-banner.png"
        />
        <meta
          name="facebook-domain-verification"
          content="m4o6pn81efn34qkf6t3fimmjnhbuxs"
        />
        <link rel="shortcut icon" href="../public/assets/images/favicon.ico" />
        <link rel="shortcut icon" href="/favicon.ico" />
        <link rel="alternate" href="https://www.paleocarcare.com/fleetrepairandmaintenance.html" hrefLang="en" />

      </Head>
      <CommonStyle>
        <Banner content={fleettopContent} />
        {/* <div className="bg-white mt-md-4 py-lg-5">
                    <div className="caption container text-center py-5 d-lg-flex justify-content-center align-items-center" >
                        <div className="col-md-8 mb-5 mb-lg-0 mx-auto col-lg-4 px-lg-1">
                            <img src={doorIconOne.src} className="img-fluid" style={{ height: 80, width: 80, }} alt="icon" />
                            <p className="mb-0 dark-text mt-4 heavy-bold big-title ">
                                Proprietary Technology
                            </p>
                            <p className='mb-0'>
                                Our homegrown technology offers end-to-end fleet maintenance and repairs, driven by our fleet management app. Our fleet management app allows us to manage your fleet and recommend preventative maintenance when they are due, greatly reducing downtime and expensive repairs.
                            </p>
                        </div>
                        <div className="col-md-8 mb-5 mb-lg-0 mx-auto col-lg-4 px-lg-1">
                            <img src={doorIconTwo.src} className="img-fluid" style={{ height: 80, width: 80, }} alt="icon" />
                            <p className="mb-0 dark-text mt-4  big-title ">
                                Access to Parts
                            </p>
                            <p className='mb-5'>Paleo has a parts store in-house with over 100k sku{`'`}s greatly reducing turnaround time by not waiting on parts deliveries. We literally pull the parts off the shelf and install them on your vehicle.</p>
                        </div>

                    </div>
                </div> */}
        <Banner content={fleetMidContent} />

        <div className="bg-white mt-md-4 py-4 py-md-5">
          <div className="container">
            <h1 className="heavy-bold text-center">How it Works</h1>
            <p className="grey-text text-center">
              We{`'`}re committed to providing you with a seamless and
              hassle-free experience.
              <br /> Rest assured that your vehicle is in good hands with our
              expert mechanics.
            </p>
            <div className="my-5">
              <div
                className="mx-auto mb-5 col-lg-10 d-lg-flex align-items-center"
                style={{ gap: 80 }}
              >
                <div className="col-10 mx-auto mx-lg-0 mb-4 mb-lg-0 col-lg-6 position-relative">
                  <Image
                    src={fleetImgOne.src}
                    className="img-fluid"
                    alt="Enter Your Request Online"
                    loading={"lazy"}
                    width="100vw"
                    height="45%"
                    layout={"responsive"}
                    style={{ borderRadius: 10 }}
                  />
                </div>
                <div className="col-10 mx-auto mx-lg-0 col-lg-4">
                  <h3 className="heavy-bold">Enter Your Request Online</h3>
                  <p className="grey-text mb-0">
                    Simply enter your repair request through our user-friendly
                    online platform. Provide details about your vehicle and the
                    issues you{`'`}re experiencing. Don{`'`}t worry, our system
                    is designed to make it easy for you to input all the
                    necessary information.
                  </p>
                </div>
              </div>
              <div
                className="mx-auto mb-5 col-lg-10 d-lg-flex align-items-center"
                style={{ gap: 80 }}
              >
                <div className="col-10 mx-auto mx-lg-0 mb-4 mb-lg-0 col-lg-6 position-relative">
                  <Image
                    src={fleetImgTwo.src}
                    className="img-fluid"
                    alt="Expert Receives The Request"
                    loading={"lazy"}
                    width="100vw"
                    height="45%"
                    layout={"responsive"}
                    style={{ borderRadius: 10 }}
                  />
                </div>
                <div className="col-10 mx-auto mx-lg-0 col-lg-4">
                  <h3 className="heavy-bold">An Expert Receives The Request</h3>
                  <p className="grey-text mb-0">
                    Once you submit your request, our team of expert mechanics
                    will promptly receive it. They have extensive knowledge and
                    experience in handling various automotive repairs. Rest
                    assured that your request is in capable hands.
                  </p>
                </div>
              </div>
              <div
                className="mx-auto mb-5 col-lg-10 d-lg-flex align-items-center"
                style={{ gap: 80 }}
              >
                <div className="col-10 mx-auto mx-lg-0 mb-4 mb-lg-0 col-lg-6 position-relative">
                  <Image
                    src={fleetImgThree.src}
                    className="img-fluid"
                    alt="We Get To Work & Keep You Updated"
                    loading={"lazy"}
                    width="100vw"
                    height="45%"
                    layout={"responsive"}
                    style={{ borderRadius: 10 }}
                  />
                </div>
                <div className="col-10 mx-auto mx-lg-0 col-lg-4">
                  <h3 className="heavy-bold">{`We Get To Work & Keep You Updated`}</h3>
                  <p className="grey-text mb-0">
                    Once we receive your request, we{`'`}ll get to work
                    diagnosing and fixing the issue. Throughout the process, we
                    {`'`}ll keep you updated with regular progress reports,
                    ensuring you{`'`}re informed every step of the way.
                  </p>
                </div>
              </div>
              <div
                className="mx-auto mb-5 col-lg-10 d-lg-flex align-items-center"
                style={{ gap: 80 }}
              >
                <div className="col-10 mx-auto mx-lg-0 mb-4 mb-lg-0 col-lg-6 position-relative">
                  <Image
                    src={fleetImgFour.src}
                    className="img-fluid"
                    alt="Quick & Easy Payment"
                    loading={"lazy"}
                    width="100vw"
                    height="45%"
                    layout={"responsive"}
                    style={{ borderRadius: 10 }}
                  />
                </div>
                <div className="col-10 mx-auto mx-lg-0 col-lg-4">
                  <h3 className="heavy-bold">{`Quick & Easy Payment`}</h3>
                  <p className="grey-text mb-0">
                    When your vehicle is ready for pickup or delivery, we{`'`}ll
                    notify you with the final details, including the cost of the
                    repair. Our payment process is quick and easy, allowing you
                    to make secure online payments. We accept various payment
                    methods to suit your convenience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="py-5 bg-danger themed-bg justify-content-center px-5"
          style={{ minHeight: 200 }}
        >
          <div className="col-lg-12" style={{ paddingRight: 10 }}>
            <h2 className="bold text-white fs-2">Partner With Us</h2>
            <p className="text-white">
              Paleo has a parts store in-house with over 100k sku{`'`}s greatly
              reducing turnaround time by not waiting on parts deliveries. We
              literally pull the parts off the shelf and install them on your
              vehicle.
            </p>
          </div>
          <div
            className="col-lg-12"
            style={{
              backgroundColor: PrimeWhite,
              padding: 20,
              borderRadius: 10,
            }}
          >
            <div id="my-hubspot-form"></div>
          </div>
        </div>
      </CommonStyle>
    </div>
  );
}

export default FleetManagment;
